import { faMegaphone } from '@fortawesome/duotone-light-svg-icons';
import { IconButton, IconButtonProps, Tooltip, useTheme } from "@mui/material";
import * as Sentry from "@sentry/react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useEffect, useRef, useState } from "react";

interface IToggleFeedbackButtonProps extends Omit<IconButtonProps, 'children'> {

}

const ToggleFeedbackButton: FC<IToggleFeedbackButtonProps> = (props) => {
    const [feedback] = useState(() => Sentry.getFeedback());
    const theme = useTheme();

    const buttonRef = useRef<HTMLButtonElement>(null);
    
    useEffect(() => {
        if (!feedback || !buttonRef.current) {
            return;
        }

        // Attach Sentry's feedback handler using the current application theme.
        const unsubscribe = feedback.attachTo(buttonRef.current, {
            colorScheme: theme.palette.mode === 'dark' ? 'dark' : 'light'
        });

        return () => {
            // Remove the previous handler before reattaching or unmounting so
            // feedback submissions do not accumulate duplicate listeners.
            unsubscribe?.();
        };
        // Re-run when the Sentry integration or theme mode changes. The
        // cleanup above detaches the old binding before the new theme is used.
    }, [feedback, theme.palette.mode]);

    if (!feedback) {
        return null;
    }

    return (
        <Tooltip 
            title="Report a Bug"
        >
            <IconButton
                aria-label="Report a Bug"
                color="inherit"
                ref={buttonRef}
                {...props}
            >
                <FontAwesomeIcon color={theme.palette.primary.light} icon={faMegaphone} fixedWidth  />
            </IconButton>
        </Tooltip>
    );
}


export default ToggleFeedbackButton;
